import withAdScreenRequest from '../../decorators/ads/withAdScreenRequest';
import MapViewRoute from './MapViewRoute';

export default withAdScreenRequest(() => 'browse')(MapViewRoute);
